import get from './methodGet';
import put from './methodPut';
import post from './methodPost';
import del from './methodDelete';

export default { ...get, ...put, ...post, ...del };
